import React, { useCallback } from "react";
import RetractableFloatingLauncher from "./RetractableFloatingLauncher";

const WHATSAPP_NUMBER = "573185078721";
const MESSAGE = encodeURIComponent(
  "¡Hola! Quiero más información sobre los servicios de Tecnotics."
);
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${MESSAGE}`;

const WhatsAppButton: React.FC = () => {
  const handleAction = useCallback(() => {
    window.open(WHATSAPP_LINK, "_blank", "noopener,noreferrer");
  }, []);

  return (
    <RetractableFloatingLauncher
      variant="whatsapp"
      ariaLabelExpand="Expandir WhatsApp"
      ariaLabelAction="Chatea por WhatsApp"
      ariaLabelRetract="Retraer WhatsApp"
      onAction={handleAction}
    >
      <i className="ri-whatsapp-fill rf-launcher__icon rf-launcher__icon--whatsapp" />
    </RetractableFloatingLauncher>
  );
};

export default WhatsAppButton;
